import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/common/PageHeader";
import Select from "react-select";
import { VERTICALS } from "../../../constants/verticals";
import { getTimeLagReport } from "../api/timelagService";

const TimeLagReport = () => {

    const [vertical, setVertical] = useState<any>(null);
    const [list, setList] = useState<any[]>([]);
const [page, setPage] = useState(1);
const [totalCount, setTotalCount] = useState(0);
const [nextPage, setNextPage] = useState<string | null>(null);
const [prevPage, setPrevPage] = useState<string | null>(null);
const [pageSize, setPageSize] = useState<number | null>(null);

const loadReport = async (pageNo: number = page) => {
            if (!vertical) return;

          const res = await getTimeLagReport({
        vertical: vertical.value,
        overdue_only: "true",
        page: pageNo, // ✅ add page
    });

    const data = res.data;

    setList(data.results || []);
    setTotalCount(data.count || 0);
    setNextPage(data.next);
    setPrevPage(data.previous);

    if (!pageSize && data.results?.length) {
        setPageSize(data.results.length);
    }

    };

    useEffect(() => {
    loadReport(page);
}, [page]);
const handleGenerate = () => {
    setPage(1);
    loadReport(1);
};
const totalPages =
    pageSize && totalCount
        ? Math.ceil(totalCount / pageSize)
        : 1;
    return (
        <>
            <PageHeader
                title="TimeLag Report"
                breadcrumbs={[
                    { label: "Dashboard", path: "/dashboard" },
                    { label: "TimeLag Report" },
                ]}
            />

            <div className="container mt-4">
                <div className="card p-4 mb-4">

                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Select Vertical</label>
                            <Select
                                options={VERTICALS.map(v => ({
                                    label: v.label,
                                    value: v.id,
                                }))}
                                value={vertical}
                                onChange={(v: any) => setVertical(v)}
                                placeholder="Select Vertical"
                            />
                        </div>

                        <div className="col-md-2 d-flex align-items-end">
                            <button className="btn btn-primary" onClick={handleGenerate}>
                                Generate
                            </button>
                        </div>
                    </div>

                </div>

                <div className="card p-4">
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
    <tr>
        <th>Inquiry Number</th>
        <th>Customer</th>
        <th>Presales Name</th>
        <th>RFQ Delay</th>
        <th>Sales Team</th>
        <th>Sales Delay</th>
        <th>Delayed By</th>
    </tr>
</thead>


                          <tbody>
    {list.length === 0 ? (
        <tr>
            <td colSpan={7} className="text-center">
                No Data
            </td>
        </tr>
    ) : (
        list.map((r: any, i: number) => (
            <tr key={i}>
                <td>{r.enquiry_number}</td>
                <td>{r.customer}</td>

                <td>{r.presales_name || "-"}</td>

                <td className={r.rfq_delay > 0 ? "text-danger fw-bold" : ""}>
                    {r.rfq_delay}
                </td>

                <td>{r.sales_team || "-"}</td>

                <td className={r.sales_delay > 0 ? "text-danger fw-bold" : ""}>
                    {r.sales_delay}
                </td>

                <td>
                    {r.delayed_team ? (
                        <span className="badge bg-danger">
                            {r.delayed_team}
                        </span>
                    ) : (
                        "-"
                    )}
                </td>
            </tr>
        ))
    )}
</tbody>
                        </table>
                        <div className="pagination d-flex gap-1 justify-content-end mt-3">
    <button
        className="btn btn-sm btn-outline-secondary"
        disabled={!prevPage}
        onClick={() => setPage(page - 1)}
    >
        Prev
    </button>

    {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
        <button
            key={p}
            className={`btn btn-sm ${
                p === page ? "btn-primary" : "btn-outline-secondary"
            }`}
            onClick={() => setPage(p)}
        >
            {p}
        </button>
    ))}

    <button
        className="btn btn-sm btn-outline-secondary"
        disabled={!nextPage}
        onClick={() => setPage(page + 1)}
    >
        Next
    </button>
</div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default TimeLagReport;
